import React from 'react'
import {
  compose, withProps, withPropsOnChange,
} from 'recompose'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import mapValues from 'lodash/mapValues'
import { Marker } from 'react-leaflet'
import Leaflet from 'leaflet'

import { getEntity } from '@infotech/lib-api-middleware'
import { MapComponent } from '@infotech/base-components'

import FieldGroup from './FieldGroup'

import './style.css'
import icon from './marker.svg'

const prepareFields = withProps(({ config: fields, submitting, initialValues, formValues }) => (
  {
    fields: mapValues(fields, (field) => (
      <FieldGroup
        {...field}
        name={field.key}
        disabled={field.disabled || submitting}
        initialValues={initialValues}
        formValues={formValues}
      />
    )),
  }
))

export const customMarker = new Leaflet.icon({
  iconUrl: icon,
  iconSize: [24, 24],
  iconAnchor: [12, 12]
})

export const defaultPosition = [55.7748556505231, 37.6335363723065]

const Layout = ({ fields, formValues, typeInfo: { code, name: typeName }, initialValues }) => {
  const {
    //tech_mode
    typeId,
    statusId,
    networkType,
    res,
    categoryCode,
    planningStartTimestamp,
    planningEndTimestamp,
    equipmentCodes,
    admDistrictCode,
    point,
    workSubject,
    directives,
    emergencyReadiness,
    'co-executor': coExecutor,
    showToSO,
    notes,
    externalAgreement,
    date_start_fact,
    date_end_fact,
    createDateEsuz,
    author,
    reporter,
    issueSourceCode,
    equipmentCodeTest,

    //tech_violation
    priority_tv,
    applicant,
    district,
    violationCharacter,
    violationClassCode,
    pp_test,
    defectiveLightingsCount,
    temporaryActions,
    eliminationStartTimestamp,
    eliminationEndTimestamp,
    executor,
    deadline,
    files,
  } = fields

  const position = formValues?.point?.point?.lat ? [formValues.point.point.lat, formValues.point.point.lon] : null

  const renderGenericForm = () => {
    const genericFields = []
    for (const key in fields) {
      if(![`typeId`, `statusId`].includes(key)) {
        genericFields.push(fields[key])
      }
    }

    return <>
      <div className="row">
        <div className="form-container col-sm-8 pt-0">
          {genericFields.map((f, i) => <div key={i} className="input-block row pt-0"><div className="col-5">
            {f}
          </div></div>)}
        </div>
      </div>
    </>
  }

  const renderTechModeForm = () => <>
    <div className="row">
      <div className="form-container col-sm-8 pt-0">
        <div className="input-block row with-border-bottom pt-0">
          <div className="col-4">
            {networkType}
          </div>
          <div className="col-4">
            {res}
          </div>
          <div className="col-4">
            {statusId}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {categoryCode}
          </div>
          <div className="col-4">
            {planningStartTimestamp}
          </div>
          <div className="col-4">
            {planningEndTimestamp}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {equipmentCodes}
          </div>          
          <div className="col-4">
            {equipmentCodeTest}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-6">
            {admDistrictCode}
          </div>
          <div className="col-6">
            {point}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-12">
            {workSubject}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-12">
            {directives}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {emergencyReadiness}
          </div>
          <div className="col-4">
            {coExecutor}
          </div>
          <div className="col-4">
            {showToSO}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-12">
            {notes}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-12">
            {externalAgreement}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {date_start_fact}
          </div>
          <div className="col-4">
            {date_end_fact}
          </div>
          <div className="col-4">
            {createDateEsuz}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {author}
          </div>
          <div className="col-4">
            {reporter}
          </div>
          <div className="col-4">
            {issueSourceCode}
          </div>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="streetpart-map">
          <MapComponent
                zoom={16}
                maxZoom={19}
                center={position ?? defaultPosition}
            >
              {position && <Marker 
                position={position}
                icon={customMarker}
              />}
            </MapComponent>
        </div>
      </div>
    </div>
  </>

  const renderTechViolationForm = () => <>
    <div className="row">
      <div className="form-container col-sm-8 pt-0">
        <div className="input-block row with-border-bottom pt-0">
          <div className="col-3">
            {priority_tv}
          </div>
          <div className="col-3">
            {statusId}
          </div>
          <div className="col-3">
            {res}
          </div>
          <div className="col-3">
            {applicant}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-4">
            {admDistrictCode}
          </div>
          <div className="col-4">
            {district}
          </div>
          <div className="col-4">
            {point}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-6">
            {violationCharacter}
          </div>
          <div className="col-6">
            {violationClassCode}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-4">
            {pp_test}
          </div>
          <div className="col-4">
            {defectiveLightingsCount}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-6">
            {temporaryActions}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-3">
            {eliminationStartTimestamp}
          </div>
          <div className="col-3">
            {eliminationEndTimestamp}
          </div>
          <div className="col-6">
            {executor}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-4">
            {author}
          </div>
          <div className="col-4">
            {createDateEsuz}
          </div>
          <div className="col-4">
            {issueSourceCode}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-3">
            {deadline}
          </div>
        </div>
        <div className="input-block row with-border-bottom">
          <div className="col-12">
            {notes}
          </div>
        </div>
        <div className="input-block row">
          <div className="col-12">
            {files}
          </div>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="streetpart-map">
          <MapComponent
                zoom={16}
                maxZoom={19}
                center={position ?? defaultPosition}
            >
              {position && <Marker 
                position={position}
                icon={customMarker}
              />}
            </MapComponent>
        </div>
      </div>
    </div>
  </>

  return (<>
    {!!initialValues && <div>
      <h4 className="mb-3">Изменение заявки {formValues.summary}</h4>
      <h6 className="mb-4">{typeName}</h6>
    </div>}
    {!initialValues && <div className="row">
        <div className="form-container col-sm-8">
          <div className="input-block row  with-border-bottom">
            <div className="col-4 mr-4">
              {typeId}
            </div>
          </div>
        </div>
    </div>}
    {(code === `tech_mode`) && renderTechModeForm()}
    {(code === `tech_violation`) && renderTechViolationForm()}
    {(!!code && (code !== `tech_mode`) && (code !== `tech_violation`)) && renderGenericForm()}
  </>)
}


export default compose(
  connect(
    (state, { form }) => {
      const formValues = getFormValues(form)(state)
      return {
        formValues,
        typeInfo: getEntity(state, `issueTypes`, formValues?.typeId) || {},
      }
    }
  ),
  prepareFields,
)(Layout)
